import {
  IonButton,
  IonContent,
  IonHeader,
  IonImg,
  IonPage,
} from '@ionic/react';
import { AppContext } from '../../lib/context/AppContext';
import { useContext } from 'react';
import Toolbar from '../../components/Toolbar';

const HomePage: React.FC = (props) => {
  const { user } = useContext(AppContext);

  return (
    <IonPage>
      <IonHeader>
        <Toolbar title='People CDRT'></Toolbar>
      </IonHeader>
      <IonContent fullscreen>
        <div className='container mx-auto py-4 px-4'>
          {!user && (
            <div className='bg-primary text-white rounded-lg p-4 mb-8'>
              <h3>Accedi al tuo account</h3>
              <p className='mt-2'>
                Registrati o accedi per poter usufruire di tutti i servizi come
                news, eventi e ricevere aggiornamenti in tempo reale.
              </p>
              <div className='mt-4'>
                <IonButton color={'light'} routerLink='/auth/sign-in'>
                  Accedi
                </IonButton>
                <IonButton
                  color={'light'}
                  routerLink='/auth/sign-up'
                  className='ml-2'
                >
                  Registrati
                </IonButton>
              </div>
            </div>
          )}

          <div className='flex flex-col'>
            <IonImg src='https://res.cloudinary.com/cdrtconsorzio/image/upload/v1690381171/static/home-1_bzmvnq.jpg'></IonImg>
            <h3 className='mt-2 mb-2'>
              People CDRT - Condividiamo passioni e costruiamo insieme ricordi
              indelebili
            </h3>
            People CDRT è molto più di un semplice Consorzio, è un'opportunità
            unica per le persone di connettersi, di sperimentare una prospettiva
            differente e coinvolgente nel vivere l'esperienza del CDRT. Qui,
            vecchi amici si incontrano e nuove amicizie prendono vita, tutto
            mentre si condividono passioni e si creano momenti indimenticabili.{' '}
            <br />
            <br />
            Far parte della comunità "gente del Cdrt" significa abbracciare un
            atteggiamento aperto verso il cambiamento e le nuove avventure,
            nutrire una naturale curiosità e partecipare attivamente a tutto ciò
            che offre. Il divertimento sano e la gioia di scoprire nuovi
            orizzonti sono il motore che ci spinge avanti.
            <br />
            <IonImg
              class='my-3'
              src='https://res.cloudinary.com/cdrtconsorzio/image/upload/v1690381171/static/home-2_emkqu4.jpg'
            ></IonImg>
            Sotto l'inconfondibile marchio People, prendono vita una serie di
            eventi unici, ciascuno con il filo conduttore delle caratteristiche
            distintive della nostra comunità. Sin dal 2012, anno in cui abbiamo
            iniziato questa entusiasmante attività, abbiamo coinvolto oltre
            1.000 persone, tutte clienti fedeli del CDRT, in straordinari tour
            enogastronomici, esperienze culturali che arricchiscono l'anima,
            appassionanti sfide sportive e indimenticabili raduni a tema.
            <br />
            L'obiettivo principale alla base dello sviluppo di questa app è
            quello di instaurare un legame più forte e significativo con i
            nostri stimati clienti. Vogliamo che siano costantemente informati e
            partecipi di tutte le magnifiche attività che abbiamo il piacere di
            organizzare durante l'anno.
            <br />
            <br />
            <IonImg
              class='mt-3'
              src='https://res.cloudinary.com/cdrtconsorzio/image/upload/v1690381171/static/home-3_a3q1zt.jpg'
            ></IonImg>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default HomePage;
